"use client";

import { lazy, Suspense } from "react";
import { motion } from "framer-motion";

const RutRotCalculator = lazy(
  () => import("@/components/guides/RutRotCalculator")
);

const CALCULATOR_MARKER = "data-component=\"rut-rot-calculator\"";

const sectionVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: "easeOut" as const },
  },
};

interface GuideContentProps {
  sections: Array<{ heading: string; html: string }>;
  locale?: "sv" | "en";
}

export default function GuideContent({ sections, locale = "sv" }: GuideContentProps) {
  return (
    <div className="space-y-10">
      {sections.map((section, i) => (
        <motion.div
          key={i}
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          <h2 className="font-heading text-2xl font-bold leading-snug text-brand-dark sm:text-3xl">
            {section.heading}
          </h2>
          {section.html.includes(CALCULATOR_MARKER) ? (
            <div className="mt-4">
              <Suspense
                fallback={
                  <div className="h-80 animate-pulse rounded-2xl bg-gray-100" />
                }
              >
                <RutRotCalculator locale={locale} />
              </Suspense>
            </div>
          ) : (
            <div
              className="guide-content mt-4 text-[1.0625rem] leading-[1.75] text-gray-700"
              dangerouslySetInnerHTML={{ __html: section.html }}
            />
          )}
        </motion.div>
      ))}
    </div>
  );
}
